import React from 'react';

const RequiredTitle = ({ 
  label, 
  validation = {},
}) => {
  return (
    <label 
      style={{ 
        position: "relative", 
        display: "inline-block", 
        paddingRight: "10px",
      }}
    >
      {label}
      {validation?.required && (
        <i
          className="fa fa-asterisk"
          style={{
            color: "red",
            fontSize: "0.6em",
            position: "absolute",
            top: "2px",
            right: "-4px"
          }}
          aria-hidden="true"
        />
      )}
    </label>
  );
};

export default RequiredTitle;
